import type { Route } from 'nextjs-routes';
import type { ComponentProps } from 'react';

import type { BlogType } from '@/services/strapi/blogs';

import type Chip from '../Chip';

export const blogTypesConfig = {
  CANDIDATE: {
    basePath: '/career-guides',
    chipVariant: 'candidate-secondary',
    hasTagFilter: false,
    hasTableOfContents: false,
    hasContactCta: false,
    hasRelatedByTag: false,
  },
  AICOMPANY: {
    basePath: '/ai-company',
    chipVariant: 'primary',
    hasTagFilter: false,
    hasTableOfContents: false,
    hasContactCta: false,
    hasRelatedByTag: false,
  },
  PRESSROOM: {
    basePath: '/press-room',
    chipVariant: 'candidate-primary',
    hasTagFilter: false,
    hasTableOfContents: false,
    hasContactCta: false,
    hasRelatedByTag: false,
  },
  CONTECH: {
    basePath: '/manufacturing-blog',
    chipVariant: 'candidate-secondary-light',
    hasTagFilter: true,
    hasTableOfContents: true,
    hasContactCta: true,
    hasRelatedByTag: true,
  },
} satisfies Record<
  BlogType,
  {
    basePath: Route['pathname'];
    chipVariant: ComponentProps<typeof Chip>['variant'];
    hasTagFilter: boolean;
    hasTableOfContents: boolean;
    hasContactCta: boolean;
    hasRelatedByTag: boolean;
  }
>;
